import { useWizard } from "@picklebet/ui";
import { convertAmountToCents } from "common/currency";
import { walletService } from "@/features/wallet/services/wallet";
import { err } from "utilities/result";
import { useSkrillEmails } from "@/hooks/firestore/user/useSkrillDeposits";
import { useWithdrawWizard } from "./useWithdrawWizard";
import type { WithdrawStepName } from "../utils/registry";

/**
 * The email is derived rather than stored on first render so the picker step
 * is optional: an account with one known email never has to open it.
 */
export const useSkrillWithdrawal = () => {
  const { goTo } = useWizard<WithdrawStepName>();
  const { skrillEmail } = useWithdrawWizard();
  const { emails, isLoading } = useSkrillEmails();

  const selectedEmail = skrillEmail ?? emails[0];

  const submit = async (amount: number) => {
    if (!selectedEmail) {
      return err(new Error("No Skrill account is available for this account"));
    }

    const result = await walletService.withdrawCash({
      amount: convertAmountToCents(amount),
      currency: "NZD",
      skrillEmail: selectedEmail,
      externalType: "SKRILL_ACCOUNT",
    });

    if (result.ok) {
      goTo("withdraw-success", { replace: true });
    }

    return result;
  };

  return { submit, selectedEmail, emails, isLoading };
};
